import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container , Grid } from 'semantic-ui-react';
import TopBar from '../components/topBar';
import Footer from '../components/footer';
import CoverPitch from './pitch/coverPitch';
import Pitch0 from './pitch/sunmiPitch';
import Pitch1 from './pitch/dPayPitch';
import Pitch2 from './pitch/devicePitch';
import Pitch3 from './pitch/uiPitch';
import Pitch4 from './pitch/webAppPitch';
import CaseStudy from './pitch/case/caseStudy';
import CaseHeader from './pitch/case/caseHeader';
import CaseFooter from './pitch/case/caseFooter';
import PriceHeader from './pitch/price/priceHeader';
import PricePitch from './pitch/price/pricePitch';
import PriceFooter from './pitch/price/priceFooter';
import TrialPitch from './pitch/trialPitch';

class PitchPage extends Component {
  shouldComponentUpdate(){
    return false;
  }
  componentDidMount(){
    const { mixpanel } = this.props;
    mixpanel.track('Pitch Page',{ action : 'browse' });
  }
  render() {
    return (
      <div>
        <TopBar/>
        <Grid stackable style={{ margin : 0 }}>
          <CoverPitch/>
					<Pitch0/>
          <Pitch1/>
          <Pitch2/>
          <Pitch3/>
          <Pitch4/>
          <CaseHeader/>
          <CaseStudy/>
          <CaseFooter/>
          <PriceHeader/>
          <PricePitch/>
          <PriceFooter/>
          <TrialPitch/>
        </Grid>
        <Footer/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(PitchPage)



/** WEBPACK FOOTER **
 ** ./src/containers/pitchPage.js
 **/